import React from "react";
import { Box, ButtonBase, makeStyles, Paper } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import PropTypes from "prop-types";

const useClasses = makeStyles(theme => ({
  productButton: {
    width: "100%",
    display: "block",
    textAlign: "left"
  },
  productButtonPaper: {
    border: `3px solid ${theme.palette.success.main}`
  },
  alert: {
    display: "inline-block",
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: `-${theme.spacing(2)}px`
  }
}));

const PaperButton = ({
  children,
  onClick,
  selected = false,
  alertText = "",
  ...rest
}) => {
  const classes = useClasses();

  return (
    <ButtonBase
      className={classes.productButton}
      disableRipple
      onClick={onClick}
      {...rest}
    >
      <Paper
        className={selected ? classes.productButtonPaper : null}
        elevation={1}
      >
        {alertText && (
          <Alert icon={false} severity="success" className={classes.alert}>
            <strong>{alertText}</strong>
          </Alert>
        )}
        <Box p={2} textAlign="center">
          {children}
        </Box>
      </Paper>
    </ButtonBase>
  );
};

PaperButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  alertText: PropTypes.string,
  children: PropTypes.any.isRequired
};

export { PaperButton };
